import SuperTagHelper from "@/components/functionals/SuperTagHelperDashBoard.vue";
// import CellHtmlHelper from "@/components/functionals/CellHtmlHelper.vue";
import CellDateTime from "@/components/functionals/DatetimeFormatter.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
//import HyperLinkSeller from "@/components/functionals/HyperLinkSeller.vue";
import Hypper from "@/components/functionals/HyperLinkDashboard.vue";
// import { formatDate } from "@/utils";
///import {formatMonto} from '../../../../utils'
export const PersonColumns = [
  {
    prop: "Employeeid",
    label: "No",
    minWidth: 50,
    sortable: true,
    fixed: true
  },
  {
    sortable: true,
    prop: "PersonName",
    label: "Nombre",
    fixed: true,
    minWidth: 220,
    formatter: ImagePerson,
    attrs: {
      imgKey: "ImageEmployee"
      //ImageEmployee
    }
  },
  // {
  //   sortable: true,
  //   prop: "Departament",
  //   label: "Departamento",
  //   minWidth: 220
  // },
  {
    sortable: true,
    prop: "January",
    label: "Enero",
    width: 110,
    formatter: Hypper,
    // formatter: HyperLinkSeller,
    cellAtrrs: {
      mes: 1
    }
  },
  {
    sortable: true,
    prop: "February",
    label: "Febrero",
    formatter: Hypper,
    width: 110,
    cellAtrrs: {
      mes: 2
    }
  },
  {
    sortable: true,
    prop: "March",
    label: "Marzo",
    formatter: Hypper,
    width: 110,
    cellAtrrs: {
      mes: 3
    }
  },
  {
    sortable: true,
    prop: "April",
    label: "Abril",
    formatter: Hypper,
    width: 110,
    cellAtrrs: {
      mes: 4
    }
  },
  {
    sortable: true,
    prop: "May",
    label: "Mayo",
    formatter: Hypper,
    width: 110,
    cellAtrrs: {
      mes: 5
    }
  },
  {
    sortable: true,
    prop: "June",
    label: "Junio",
    formatter: Hypper,
    width: 110,
    cellAtrrs: {
      mes: 6
    }
  },
  {
    sortable: true,
    prop: "July",
    label: "Julio",
    formatter: Hypper,
    width: 110,
    cellAtrrs: {
      mes: 7
    }
  },
  {
    sortable: true,
    prop: "August",
    label: "Agosto",
    formatter: Hypper,
    width: 110,
    cellAtrrs: {
      mes: 8
    }
  },
  {
    sortable: true,
    prop: "September",
    label: "Septiembre",
    formatter: Hypper,
    width: 130,
    cellAtrrs: {
      mes: 9
    }
  },
  {
    sortable: true,
    prop: "October",
    label: "Octubre",
    formatter: Hypper,
    width: 110,
    cellAtrrs: {
      mes: 10
    }
  },
  {
    sortable: true,
    prop: "November",
    label: "Noviembre",
    formatter: Hypper,
    width: 120,
    cellAtrrs: {
      mes: 11
    }
  },
  {
    sortable: true,
    prop: "December",
    label: "Diciembre",
    formatter: Hypper,
    width: 110,
    cellAtrrs: {
      mes: 12
    }
  }
];
export const ManagementColumns = {};
export const DeparmentColumns = {};
export const ActionTask = [
  {
    icon: "el-icon-view",
    label: "Editar",
    command: "view-see-objetive"
  }
];
export const ActionPending = [
  {
    icon: "el-icon-check",
    label: "Aprobar",
    command: "view-see-Approve"
  }
];
export const TaskColumns = [
  {
    prop: "DisplayObjet",
    label: "# Obj.",
    width: 90,
    sortable: true,
    fixed: true
  },
  {
    prop: "ObjetiveName",
    label: "Objetivo",
    minWidth: 180,
    sortable: true,
    fixed: false
  },
  {
    prop: "DisplayTask",
    label: "# Tr.",
    width: 80,
    sortable: true,
    fixed: false
  },
  {
    prop: "Name",
    label: "Tarea",
    minWidth: 180,
    sortable: true,
    fixed: false
  },

  {
    prop: "LimitDate",
    label: "Fecha compromiso",
    width: 180,
    sortable: true,
    fixed: false,
    // formatter: row => formatDate(row.LimitDate, "DD/MM/yyyy")
    formatter: CellDateTime
    // formatter: row => CellDateTime(row.LimitDate, "DD/MM/yyyy")
  },
  {
    prop: "ClosedDate",
    label: "Fecha cierre",
    width: 180,
    sortable: true,
    fixed: false,
    // formatter: row => formatDate(row.ClosedDate, "DD/MM/yyyy")
    formatter: CellDateTime
    //     formatter: row => CellDateTime(row.ClosedDate, "DD/MM/yyyy")
  },
  {
    prop: "Effort",
    label: "Estimación",
    width: 120,
    sortable: true,
    fixed: false
  },
  /*
  {
    //la propiedad percent se cambio a porcentaje
    prop: "Percentage",
    label: "%",
    width: 80,
    sortable: true,
    fixed: false
  },
  */
  {
    prop: "DiasRetrasados",
    label: "Dias retrasada",
    width: 140,
    sortable: true,
    fixed: true
  },
  {
    prop: "Status",
    label: "Estatus",
    width: 130,
    sortable: true,
    fixed: false,
    attrs: {
      tagType: "success",
      tagValue: "palomo"
    },
    formatter: SuperTagHelper
  }
];
